import { createSlice } from '@reduxjs/toolkit';
import { TransportationTimeMapping } from 'src/components/map';
import { dispatch } from '../store';

type FiltersInMap = {
  tourReason: string;
  tourType: string;
  transportationTime: TransportationTimeMapping[];
};

const initialState: FiltersInMap = {
  tourReason: '',
  tourType: '',
  transportationTime: [],
};

const filtersInMapSlice = createSlice({
  name: 'filtersInMap',
  initialState,
  reducers: {
    setTourReasonFilterInMap(state, action) {
      state.tourReason = action.payload;
    },
    setTourTypeFilterInMap(state, action) {
      state.tourType = action.payload;
    },
    setTransportationTimeFilterInMap(state, action) {
      state.transportationTime = action.payload;
    },
  },
});

export default filtersInMapSlice.reducer;

export function setTourReasonFilterInMap(tourReason: string) {
  dispatch(filtersInMapSlice.actions.setTourReasonFilterInMap(tourReason));
}

export function setTourTypeFilterInMap(tourType: string) {
  dispatch(filtersInMapSlice.actions.setTourTypeFilterInMap(tourType));
}

export function setTransportationTimeFilterInMap(transportationTime: TransportationTimeMapping[]) {
  dispatch(filtersInMapSlice.actions.setTransportationTimeFilterInMap(transportationTime));
}
